import { EventType } from '@diritto/common/event/constants';
import { EventResponseDto } from '@diritto/common/event/dtos/event.dto';
import { TrackingEventType } from '@diritto/common/tracker/tracking-event.constant';
import { useTrackingState } from 'contexts/TrackingProvider';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { EventAppInstallView } from 'app-components/events/EventAppInstallView';
import { EventNewContentPromoteView } from 'app-components/events/EventNewContentPromoteView';
import { EventNormalView } from 'app-components/events/EventNormalView';

interface EventViewProps {
  eventData: EventResponseDto;
}

export const EventView = ({ eventData }: EventViewProps) => {
  const { tracker } = useTrackingState();
  const { event } = eventData;

  useEffect(() => {
    tracker.track(TrackingEventType.ViewEvent, { eventId: event.id });
  }, [event.id, tracker]);

  switch (event.type) {
    case EventType.AppInstallEvent:
      return <EventAppInstallView eventData={eventData} />;
    case EventType.NewContentPromoteEvent:
      return <EventNewContentPromoteView eventData={eventData} />;
    case EventType.NormalEvent:
      return <EventNormalView eventData={eventData} />;
    case EventType.PromotionEvent:
      return <RedirectToPromotionPage eventData={eventData} />;
    default:
      return null;
  }
};

const RedirectToPromotionPage = ({ eventData }: EventViewProps) => {
  const router = useRouter();
  const { event } = eventData;
  const { extraInfo } = event;
  const path = extraInfo.payload?.redirectUrl || '/';

  useEffect(() => {
    router.replace(path);
  }, [path, router]);
  return null;
};
